import React, { useState, useEffect } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Row,
  Col,
  InputGroup,
  Input,
  Label,
  Form,
  Table,
} from "reactstrap";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";

import PaymentReportService from "../../../services/OrderingServices/PaymentReportService";
import {
  formatDate,
  formatDateTime,
} from "../../../Components/Common/FormatDate";
// import LayoutWithBreadCrumb from "../../../pages/Pages/Starter/LayoutWithBreadCrumb";
import PrintHeader from "../component/PrintHeader";
import PaymentTypeServices from "../../../services/OrderingServices/PaymentTypeService";
// import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

const PaymentReport = () => {
  const [paymentTypeData, setPaymentTypeData] = useState([]);
  const [selectedPaymentId, setSelectedId] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [transactions, setTransactions] = useState([]);

  const [isPrinting, setIsPrinting] = useState(false);

  const paymenTypeOption = paymentTypeData.map((bank) => ({
    value: bank.id,
    label: bank.name,
  }));

  const handleBankChange = (selectedOption) => {
    setSelectedId(selectedOption ? selectedOption.value : "");
  };

  async function fetchBankTransactions(id, start, end) {
    try {
      const response = await PaymentReportService.getList(id, start, end);

      const transformed = response.map((tx) => ({
        transactionId: tx.invoiceNumber,
        valueDate: tx.transactionDate,
        remarks: "-",
        transactionType: tx.debit > 0 ? "Debit" : "Credit",
        amount: tx.debit > 0 ? tx.debit : tx.credit,
        transactionCreatedBy: "System",
      }));

      setTransactions(transformed);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  }

  useEffect(() => {
    async function fetchBanks() {
      try {
        const response = await PaymentTypeServices.getList();
        setPaymentTypeData(response);
      } catch (error) {
        console.error("Error fetching bank list:", error);
      }
    }

    fetchBanks();
  }, []);

  const handleReportClick = () => {
    if (!selectedPaymentId) return;

    // Convert Date objects to ISO strings (YYYY-MM-DD)
    const formatDate = (date) => {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; // ISO format
    };

    const fromDate = formatDate(startDate);
    const toDate = formatDate(endDate);

    fetchBankTransactions(selectedPaymentId, fromDate, toDate);
  };

  const handlePrint = () => {
    setIsPrinting(true);
    setTimeout(() => {
      window.print();
      setIsPrinting(false);
    }, 500);
  };
  useEffect(() => {
    const today = new Date();
    const oneMonthBefore = new Date();
    oneMonthBefore.setMonth(today.getMonth() - 1);

    setStartDate(oneMonthBefore);
    setEndDate(today);
  }, []);

  return (
    <React.Fragment>
      {/* <LayoutWithBreadCrumb
        title="Payment Statement Report"
        pageTitle="Payment Statement Report"
      > */}
        <Card>
          <CardBody>
            <PrintHeader reportTitle="Payment Statement Report" />
            <Form className="d-print-none">
              <Row className=" align-items-end">
                <Col sm={3}>
                  <Label>Payment Type</Label>
                  <Select
                    value={paymenTypeOption.find(
                      (option) => option.value === selectedPaymentId
                    )}
                    onChange={handleBankChange}
                    options={paymenTypeOption}
                    isClearable
                  />
                </Col>
                <Col sm={3}>
                  <Label>Start Date</Label>
                  <Flatpickr
                    value={startDate}
                    onChange={([date]) => setStartDate(date)}
                    options={{
                      dateFormat: "d/m/Y", // DD/MM/YYYY format
                      maxDate: new Date(), // cannot select future date
                    }}
                    className="form-control"
                  />
                </Col>
                <Col sm={3}>
                  <Label>End Date</Label>
                  <Flatpickr
                    value={endDate}
                    onChange={([date]) => setEndDate(date)}
                    options={{
                      dateFormat: "d/m/Y",
                      minDate: startDate, // cannot be before startDate
                      maxDate: new Date(), // cannot select future date
                    }}
                    className="form-control"
                  />
                </Col>
                <Col sm={3} className="text-end">
                  <Button
                    onClick={handleReportClick}
                    className="me-2"
                    disabled={!selectedPaymentId}
                  >
                    Generate Report
                  </Button>
                  {transactions.length > 0 && (
                    <Button
                      color="outline-secondary"
                      className="py-2 px-3 d-inline-flex align-items-center shadow-sm"
                      onClick={handlePrint}
                    >
                      <i className="ri-printer-line fs-16 me-1"></i>
                    </Button>
                  )}
                </Col>
              </Row>
            </Form>

            <Row>
              {transactions.length > 0 && (
                <Card className="shadow-sm border-0">
                  <CardBody className="p-4">
                    <h5 className="mb-4 text-center font-weight-bold d-print-none">
                      Payment Statement Information
                    </h5>

                    <div className="table-responsive">
                      <Table bordered hover className="mb-0 table-nowrap">
                        <thead className="bg-light">
                          <tr>
                            <th style={{ width: "60px" }}>S.N</th>
                            <th style={{ width: "180px" }}>Transaction ID</th>
                            <th style={{ width: "130px" }}>Date</th>
                            <th>Remarks</th>
                            <th style={{ width: "120px" }} className="text-end">
                              Debit
                            </th>
                            <th style={{ width: "120px" }} className="text-end">
                              Credit
                            </th>
                            <th style={{ width: "150px" }}>Transaction By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {transactions && transactions.length > 0 ? (
                            transactions.map((item, index) => (
                              <tr key={item.transactionId || index}>
                                <td>{index + 1}</td>
                                <td>
                                  <Link to={`/order/${item?.transactionId}`}>
                                    {item.transactionId}
                                  </Link>
                                </td>
                                <td>{formatDate(item.valueDate)}</td>
                                <td>{item.remarks}</td>
                                <td className="text-end">
                                  {item.transactionType === "Debit" ? (
                                    <NumberWithCommas number={item.amount} />
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td className="text-end">
                                  {item.transactionType === "Credit" ? (
                                    <NumberWithCommas number={item.amount} />
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>{item.transactionCreatedBy}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                No transactions available.
                              </td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot className="font-weight-bold">
                          <tr>
                            <td colSpan="4" className="text-end">
                              Total
                            </td>
                            <td className="text-end">
                              <NumberWithCommas
                                number={transactions
                                  .filter((t) => t.transactionType === "Debit")
                                  .reduce((sum, t) => sum + t.amount, 0)}
                              />
                            </td>
                            <td className="text-end">
                              <NumberWithCommas
                                number={transactions
                                  .filter((t) => t.transactionType === "Credit")
                                  .reduce((sum, t) => sum + t.amount, 0)}
                              />
                            </td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              )}
            </Row>
          </CardBody>
        </Card>
    </React.Fragment>
  );
};

export default PaymentReport;
